import "./MediaUploadPage.scss";
import * as React from "react";
import MediaUpload from "../../../components/MediaUpload/MediaUpload";
import {marked} from 'marked';
import { LOGO_MAX_SIZE, LOGO_SUPPORT_TYPES, BANNER_MAX_SIZE, BANNER_SUPPORT_TYPES, fileDescriptionBanner, fileDescriptionLogo } from "../../../constants/upload";
import { ADMIN_ROLE, Context } from "../ModulePage/exportfiles";
import { getRefValue, openWindow } from "../../../utils/utils";
import { DEFAULT_LINK, SUPPORT_SITE_LINK } from "../../../constants/references";

const MediaUploadPage = ({logoMediaMeta, setLogoMediaMeta, onUpload, org_role, org_id, bannerMediaMeta, setBannerMediaMeta}) => {
const {state: { reminderData } } = React.useContext(Context);
const [userGuideLink, setUserGuideLink] = React.useState(DEFAULT_LINK);
  React.useEffect(()=>{
    let mount = true;
    const fetchmedia = async () => {
      try {
        const mediaData = {
          mediaUploads: [
              {
                  "id": 830,
                  "module_id": 33,
                  "question_group_id": 133,
                  "category_id": 9,
                  "status": "",
                  "timestamp": "2023-09-13 07:33:00.091 -0800",
                  "imageName": "jim1.jpg",
                  "size": "300K"
              },
              {
                "id": 831,
                "module_id": 34,
                "question_group_id": 134,
                "category_id": 9,
                "status": "pending",
                "timestamp": "2023-09-14 07:33:00.091 -0800",
                "imageName": "jim2.jpg",
                "size": "300K"
            }
          ]
        };
        if(mount){
          if(mediaData && mediaData.mediaUploads) {
            setLogoMediaMeta(mediaData.mediaUploads[0]);
            setBannerMediaMeta(mediaData.mediaUploads[1]);
          }
        
        }
      } catch (err) {
        console.log(err);
      }
    };

    if(mount){
      const guideLink = getRefValue(reminderData, SUPPORT_SITE_LINK);
      setUserGuideLink((guideLink === -1) ? DEFAULT_LINK : guideLink);
      fetchmedia();
    }
    return() => {
      mount = false;
    };
  }, []);


   const markUpConverter = (val) => {
    return { __html: marked(val) }
   }
  return(
    <div className="uploadSection">
      <div className='cb-accordion col-md-12 category-header' data-cb-apricot='accordion'>
            <h3 className="cb-font-weight-regular category-name">Upload Media</h3>
        <div className="cb-accordion-controls" style={{ marginBottom: '25px' }}>
          <div className="cb-accordion-title" style={{flex: '1'}}>
          <div className='category-subheader'>
          Upload your files according to the listed specifications. Once they are successfully uploaded, they will be reviewed by the BigFuture team before being accepted to your institution’s profile.
          </div>
          </div>
          <div className="cb-accordion-buttons">
            <button type="button" className="cb-btn cb-btn-greyscale cb-accordion-expand" onClick={()=>openWindow(userGuideLink)}>View guideline PDF</button>
            <button type="button" className="cb-btn cb-btn-greyscale cb-accordion-collapse" onClick={()=>openWindow(userGuideLink)}>Support</button>
          </div>

        </div>
      <div role="region" aria-label="uploadmedia" id='uploadMediaContent'>
        <div className="media-main">
        <h3 className="cb-font-weight-regular media-subheader">Upload Logo</h3>
            <div className='uploadPanel'>
              <div className="left-container">
                <MediaUpload  mediaMeta={logoMediaMeta} 
                              setMediaMeta={setLogoMediaMeta} 
                              onUpload={onUpload} 
                              org_role={org_role} 
                              org_id={org_id} 
                              uploadType='logo'
                              uploadLimit={{'maxSize': LOGO_MAX_SIZE, 'types': LOGO_SUPPORT_TYPES}}/>
              </div>

              {(org_role !== ADMIN_ROLE) &&
               <div className="right-container">
                  <div className="half-containers margin-bottom" >
                    <div className="upload-restrictions" dangerouslySetInnerHTML={markUpConverter(fileDescriptionLogo)} />
                  </div>
              </div>  } 
            </div>
        </div>

        <div className="media-main">
        <h3 className="cb-font-weight-regular media-subheader">Upload Banner</h3>
            <div className='uploadPanel'>
              <div className="left-container">
                <MediaUpload  mediaMeta={bannerMediaMeta} 
                              setMediaMeta={setBannerMediaMeta} 
                              onUpload={onUpload} 
                              org_role={org_role}
                              org_id={org_id}
                              uploadType='banner'
                              uploadLimit={{'maxSize':BANNER_MAX_SIZE, 'types':BANNER_SUPPORT_TYPES}}/>
              </div>
              {(org_role !== ADMIN_ROLE) &&
                <div className="right-container">
                  <div className="half-containers margin-bottom">
                  <div className="upload-restrictions" dangerouslySetInnerHTML={markUpConverter(fileDescriptionBanner)} />
                  </div>
              </div>  }
          </div> 
        </div>
      </div>
      </div>
    </div>
  );
};

export default MediaUploadPage;